import { StoredMatch } from './types';

export const parseTeamNames = (label: string): { home: string; away: string } => {
  if (!label) return { home: 'Home', away: 'Away' };
  const commaIdx = label.lastIndexOf(',');
  const teamsPart = commaIdx > -1 ? label.substring(0, commaIdx) : label;
  const separatorIdx = teamsPart.indexOf(' - ');
  if (separatorIdx === -1) return { home: teamsPart.trim(), away: 'Away' };
  return {
    home: teamsPart.substring(0, separatorIdx).trim(),
    away: teamsPart.substring(separatorIdx + 3).trim(),
  };
};

export const formatMatchOption = (m: StoredMatch, teamId: number | null) => {
  const names = parseTeamNames(m.label);
  const isHome = teamId !== null && m.homeTeamId === teamId;
  const opponent = isHome ? names.away : names.home;
  const venue = isHome ? 'H' : 'A';
  const d = new Date(m.dateUtc.replace(' ', 'T'));
  const dateStr = d.toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric' });
  return `vs ${opponent} (${venue}) ${dateStr} - ${m.homeScore}-${m.awayScore}`;
};
